/**
 * Etapa 5 — Fotos: carrega as fotos do posto e entrega a grade (abertura separada, registro em 4×2).
 * Cada foto grava na hora; sem permissão de editar a etapa só mostra.
 */
import React, { useCallback } from 'react';
import { Alert, Box, Button, CircularProgress, Typography } from '@mui/material';
import { ergonomicWorkstationService } from '../../../../../services/ergonomicWorkstationService';
import { useItems } from '../useItems';
import { DEFAULT_PHOTO_LIMITS, PhotoGrid } from '../PhotoGrid';
import type { WizardStepProps } from '../Wizard.types';

export const PhotosStep: React.FC<WizardStepProps> = ({ workstation, options, canEdit, disabled, onSaved }) => {
  const workstationId = workstation.id;
  const loadPhotos = useCallback(() => ergonomicWorkstationService.getPhotos(workstationId), [workstationId]);
  const photos = useItems(loadPhotos, 'Não foi possível carregar as fotos.');

  return (
    <Box>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Mostre o posto como ele é: o lugar, a postura de quem trabalha e a bancada. Cada foto é guardada assim que o
        envio termina.
      </Typography>

      {photos.loading && (
        <Box role="status" sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CircularProgress size={20} />
          <Typography variant="body1">Carregando as fotos…</Typography>
        </Box>
      )}

      {!photos.loading && photos.error && (
        <Alert
          severity="error"
          sx={{ fontSize: '1rem' }}
          action={
            <Button color="inherit" onClick={photos.reload} sx={{ minHeight: 44 }}>
              Tentar de novo
            </Button>
          }
        >
          {photos.error}
        </Alert>
      )}

      {!photos.loading && !photos.error && (
        <PhotoGrid
          workstationId={workstationId}
          initialPhotos={photos.items}
          limits={options?.photoLimits ?? DEFAULT_PHOTO_LIMITS}
          canEdit={canEdit}
          disabled={disabled}
          onSaved={onSaved}
        />
      )}
    </Box>
  );
};

export default PhotosStep;
